import { PromiseObservable } from './PromiseObservable';
export var fromPromise = PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map